import { orderStatusHistory } from '@/config'

const detail = {
  line1: [
    {
      name: 'supplierName',
      text: 'order.order_supplier-name',
      component: 'MultipleSelectSupplierName'
    },
    {
      name: 'orderDate',
      text: 'order.order_order-date',
      component: 'FromToDatePicker'
    },
    {
      name: 'withdrawDate',
      text: 'storage.storage_payment-date',
      component: 'FromToDatePicker'
    },
    {
      name: 'completionDate',
      text: 'sale.sale_completion-date',
      component: 'FromToDatePicker'
    },
    {
      name: 'loadingDate',
      text: 'loading.loading_loading-date',
      component: 'FromToDatePicker'
    }
  ],
  line2: [
    {
      name: 'withdrawStatus',
      text: 'sale.sale_payment-status',
      component: 'SelectStatusOrder',
      type: orderStatusHistory.STATUS_HISTORY_TYPE_ID.WITHDRAW
    },
    {
      name: 'loadingStatus',
      text: 'order.order_loading-status',
      component: 'SelectStatusOrder',
      type: orderStatusHistory.STATUS_HISTORY_TYPE_ID.LOADING
    },
    {
      name: 'orderStatus',
      text: 'order.order_order-status',
      component: 'SelectStatusOrder',
      type: orderStatusHistory.STATUS_HISTORY_TYPE_ID.COMPLETE
    },
    {
      name: 'createUser',
      text: 'sale.sale_author',
      component: 'SelectCreateUserClearable'
    }
  ],
  line3: [
    {
      name: 'currency',
      text: 'common.input_currency',
      component: 'SearchCurrency'
    },
    {
      name: 'amountRange',
      text: 'sale.sale_price',
      component: 'SearchAmountRange'
    },
    {
      name: 'orderInfo',
      text: 'order.order_order-info',
      component: 'SearchOrderInfo'
    },
    {
      name: 'productInfo',
      text: 'sale.sale_product-info',
      component: 'SearchProductNoAndProductCategory'
    },
    {
      name: 'productName',
      text: '',
      component: 'SearchProductName'
    }
  ],
  line3_OutsideStaff: [
    {
      name: 'currency',
      text: 'common.input_currency',
      component: 'SearchCurrency'
    },
    {
      name: 'orderInfo',
      text: 'order.order_order-info',
      component: 'SearchOrderInfo'
    },
    {
      name: 'productInfo',
      text: 'sale.sale_product-info',
      component: 'SearchProductNoAndProductCategory'
    },
    {
      name: 'productName',
      text: '',
      component: 'SearchProductName'
    }
  ]
}

export default { detail }
